import { useMemo } from "react";
import type { NavItem } from "@/components/app-sidebar/app-sidebar";
import { featureNavItems } from "@/components/app-sidebar/feature-nav-config";
import { useEntityPermissionsMap } from "@/hooks/schema/use-my-permissions";
import { useEntityStore } from "@/stores/entity.store";

/** Feature pages whose `requiresEntity` exists and is readable by the current user. */
export const useVisibleFeatureNavItems = (): NavItem[] => {
  const entityMapForNames = useEntityStore((state) => state.entityMapForNames);
  const { entityPermissionsMap } = useEntityPermissionsMap();

  return useMemo(
    () =>
      featureNavItems.filter((item) => {
        if (!item.requiresEntity) return true;
        const entity = entityMapForNames.get(item.requiresEntity);
        return !!entity && !!entityPermissionsMap.get(entity.id)?.has_read;
      }),
    [entityMapForNames, entityPermissionsMap],
  );
};
